import { getMockInstalledUpiIntentsStoragePayload } from '../../data/mockInstalledUpiIntents'
import {
  getInstalledUpiAppsFromStorage,
  notifyInstalledUpiIntentsFromFlutter,
} from '../installedUpiIntents'
import { isDevEnvironment } from '../utils'

/** Writes mock UPI intents to storage and notifies listeners (development only). */
export function applyDevMockInstalledUpiIntents(): boolean {
  if (!isDevEnvironment()) {
    return false
  }

  const payload = getMockInstalledUpiIntentsStoragePayload()
  localStorage.setItem('installedUpiApps', payload)
  notifyInstalledUpiIntentsFromFlutter(payload)
  return true
}

/** Seeds mocks on first load when storage is empty so UPI flows work without Flutter. */
export function seedDevMockInstalledUpiIntentsOnBoot(): void {
  if (!isDevEnvironment()) return
  if (getInstalledUpiAppsFromStorage().length > 0) return

  applyDevMockInstalledUpiIntents()
}
